import React, { useCallback } from "react";
import styled from "styled-components";
import { useScreenWidth } from "../../helper/screentWidth";

function CustomTextArea({ Title, Active, Type, value, onChange, placeholder, Flex = false }) {
  const screenWidth = useScreenWidth();
  const handleChange = useCallback(
    (e) => {
      onChange(e.target.value);
    },
    [onChange]
  );

  return (
    <Container Flex={Flex}>
      <FieldName Flex={Flex}>{Title}</FieldName>
        <CustomField
          value={value}
          disabled={!Active}
          type={Type ? Type : "text"}
          onChange={handleChange}
          placeholder={placeholder}
        />
      
    </Container>
  );
}

const Container = styled.div`
  display: grid;
  grid-template-columns: 1fr ;
  align-items: center;
  width: 100%;
  @media screen and (max-width: ${props => props.firstmeeting ? "983px" : "690px"}) {
    grid-template-columns: 1fr;
    gap: 10px;
  }
`;

const FieldName = styled.div`
    justify-self: start;
  color: #304961;
  font-family: "Museo Sans Cyrl";
  font-size: 14px;
  font-style: italic;
  font-weight: 300;
  @media screen and (max-width: ${(props) =>
      props.firstmeeting ? "983px" : "690px"}) {
    padding: 20px 0px 0px 0px;
  }
`;


const Text = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  border-radius: 5px;
  min-width: 80px;
  min-height: 100px;
  padding: 10px;
  color: #304961;
  font-family: "Museo Sans Cyrl";
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 30px;
  white-space: pre-wrap;
  word-wrap: break-word;

`;

const CustomField = styled.textarea`
  outline: none;
  border: none;
  border-radius: 5px;
  padding: 10px;
  background-color: var(--editable);
  opacity: ${(props) => (props.disabled ? "0.5" : "1")};
  width: 100%;
  min-height: 100px;
  color: #304961;
  font-family: "Museo Sans Cyrl";
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 30px;
  resize: vertical;
  
  &::placeholder {
    font-size: 14px;
    font-weight: 400;
    color: #8a9ba8;
  }
`;

export default CustomTextArea;
